import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import logo from "../images/Lgog.png";


export default function Header() {
  const { me, login, logout } = useAuth();
  return (
    <header className="header">
      <div className="container header-inner">
        <div className="brand">
          <img className="brand-logo" src={logo} alt="AZFM Logo" />
          <div className="brand-text">
          <div className="brand-name">AZ Facility Management</div>
          <div className="brand-tag">Reliable • Responsive • UA Proud</div>
        </div>
      </div>
      <div className="sub-header">
      </div>
        <nav className="nav">
          {/* AUTH LINK */}
        {!me.loggedIn ? (
          <span
            className="nav-link nav-auth"
            onClick={() => login(window.location.pathname)}
            role="button"
            tabIndex={0}
          >
            Log In
          </span>
        ) : (
          <span
            className="nav-link nav-auth"
            onClick={logout}
            role="button"
            tabIndex={0}
          >
            Log Out
          </span>
        )}
        <NavLink to="/" end className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Home</NavLink>
        <NavLink to="/request" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Request Service</NavLink>
        <NavLink to="/paynow" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>Pay Now</NavLink>
        </nav>
      </div>
    </header>
  
 
  );
}